import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: capitalDesignTokens.semanticColors.background.secondary,
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    background: capitalDesignTokens.semanticColors.background.secondary,
  },
  tabBarContent: {
    display: 'flex',
    marginTop: '16px',
  },
  content: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    height: '100%',
  },
  deactivateBanner: {
    lineHeight: 1.25,
    margin: '24px',
    '& .MuiAlert-message': {
      width: '100%',
    },
  },
  bannerDetailContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: '16px',
    marginRight: '8px',
    '& ul > li': {
      color: capitalDesignTokens.semanticColors.foreground.primary,
    },
  },
  deactivateButton: {
    marginTop: '-16px',
    height: '32px',
  },
  deactivateAnchorUrl: {
    display: 'inline-block',
    verticalAlign: 'middle',
    maxWidth: '650px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    lineHeight: 1.25,
    height: '1.25rem',
    '&::before': {
      content: '"\\00a0 "',
    },
  },
});
